import { IsNotEmpty, IsString } from 'class-validator';

export class TimeUsuariosCriarDto {
  @IsString()
  @IsNotEmpty()
  usuarioId: string;
}
